import { Link } from "react-router-dom";
import { usePlans } from "../hooks/usePlans";
import { useLocale } from "../i18n/LocaleContext";
import PlanCard from "./PlanCard";

const MAX_SPECIALS = 6;

// Landing "Specials" strip: plans flagged offer:true by the scraper
// (listed on megatravel.com.mx/viajes-ofertas). Hidden when none are flagged
// (see docs/DESIGN.md, decision D5).
const SpecialsStrip = () => {
    const { data } = usePlans();
    const { t } = useLocale();
    const offers = data.plans.filter((p) => p.offer).slice(0, MAX_SPECIALS);
    if (offers.length === 0) return null;

    const destinationName = new Map(data.destinations.map((d) => [d.id, d.name]));

    return (
        <section className="home-section home-specials" id="ofertas">
            <div className="home-section-inner">
                <p className="kicker">{t.specials.kicker}</p>
                <h2>{t.specials.title}</h2>
                <p className="section-sub">{t.specials.sub}</p>
                <div className="plan-grid">
                    {offers.map((plan) => (
                        <PlanCard
                            key={plan.id}
                            plan={plan}
                            destinationName={t.destNames[plan.destinationId] ?? destinationName.get(plan.destinationId)}
                        />
                    ))}
                </div>
                <Link className="specials-more" to="/destinos">
                    {t.specials.more(data.plans.length)}
                </Link>
            </div>
        </section>
    );
};

export default SpecialsStrip;
